import React from 'react'
import PropTypes from 'prop-types'
import { STEPS } from '../hooks'

const Stepper = ({ currentStep }) => (
  <nav className="mb-4">
    <div className="d-inline-flex align-items-center bg-light border rounded px-3 py-2">
      {STEPS.map((stepItem, index) => (
        <React.Fragment key={stepItem.key}>
          <span className={currentStep === stepItem.key ? 'font-weight-bolder' : ''}>
            {stepItem.label}
          </span>
          {index < STEPS.length - 1 && 
            <i className="fas fa-chevron-right mx-2 text-muted small" />}
        </React.Fragment>
      ))}
    </div>
  </nav>
)

Stepper.propTypes = {
  currentStep: PropTypes.number.isRequired
}

export default Stepper
